export const errorsTranslations = {
  generic: {
    "User does not exist.":
      "Não encontramos uma conta com o e-mail informado. Por favor, verifique se o e-mail digitado está correto e tente novamente.",
    "Incorrect username or password.":
      "E-mail e/ou senha incorretos. Por favor, verifique se as informações estão corretas e tente novamente.",
    "Invalid password format.": "O formato da senha é inválido.",
    "Username/client id combination not found.":
      "Não foi localizado nenhum cadastro com este e-mail.",
    "Attempt limit exceeded, please try after some time.":
      "Muitas tentativas de recuperação de senha. Por favor, tente novamente mais tarde ou entre em contato com o suporte.",
    "Invalid verification code provided, please try again.":
      "O código informado não é válido. Por favor, verifique e tente novamente.",
    "Password attempts exceeded":
      "Tentativas de senha excedidas, tente novamente mais tarde ou entre em contato com o suporte.",
    "Code expired":
      "O seu acesso expirou. Entre com o seu e-mail e tente novamente.",
  },

  changePassword: {
    "Incorrect username or password.":
      "Senha atual não confere. Por favor, verifique se a senha atual está correta e tente novamente.",
  },

  fallback:
    "Houve um problema, por favor, verifique os dados e tente novamente.",
};

/**
 * Translate Amplify Error message
 * @param {string} amplifyMessage
 * @param {'generic' | 'changePassword'} context
 * @returns {TAmplifyErrorMessage}
 */
export const translateAmplifyErrorMessage = (
  amplifyMessage,
  context = "generic"
) => {
  const message =
    errorsTranslations[context]?.[amplifyMessage] ||
    errorsTranslations["generic"]?.[amplifyMessage];

  return {
    message: message || errorsTranslations["fallback"],
  };
};
